export const PIE_CHART_COLORS = ['#BF3030', '#698979'];
